<template>
  <div>
    <el-dialog
    :append-to-body="true"
     :close-on-click-modal="false"
      title="分配角色"
      :visible.sync="assignDialogVisible"
      width="30%"
      :before-close="closeDialog">
      <el-form label-width="80px" ref="ruleForm"  :rules="rules" :model="form">
        <!-- <el-form-item label="用户id" prop="userId">
          <el-input v-model="form.userId" autocomplete="off" placeholder="请输入用户名" :disabled="true"></el-input>
        </el-form-item> -->
        <el-form-item label="角色" prop="roleIds">
          <el-select
          style="width:100%"
          v-model="form.roleIds"
          :multiple="true"
          filterable
          class="sel"
          ref="deviceScope"
          @focus="focusStatus&&openDrawer()"
          >
            <el-option
              v-for="item in charactorOptions"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <Drawer
    v-if="drawerFlag"
    :accessData="accessData"
    :drawerFlag="drawerFlag"
    @closeDrawer = "closeDrawer"
    @getData="receive"/>
  </div>
</template>
<script>
import { bindRole, listByUserId } from '@/api/user'
import Drawer from './drawer'
export default {
  props: {
    assignDialogVisible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: Number
    }
  },
  data () {
    return {
      form: {},
      rules: {},
      charactorOptions: [],
      // 抽屉
      drawerFlag: false,
      focusStatus: true,
      accessData: []
    }
  },
  components: {
    Drawer
  },
  created () {
    this.form.userId = this.userId
    this.getRoleList()
  },
  methods: {
    // 打开抽屉
    openDrawer () {
      this.drawerFlag = true
      this.$refs.deviceScope.blur()
      this.focusStatus = false
      this.accessData = Object.assign([], this.charactorOptions)
    },
    // 关闭抽屉
    closeDrawer () {
      this.drawerFlag = false
      this.focusStatus = true
    },
    // 获取子组件数据
    receive (val) {
      console.log('子组件数据', val)
      this.charactorOptions = val
      this.form.roleIds = val.map(res => res.roleId)
      this.drawerFlag = false
      this.focusStatus = true
    },
    getRoleList () {
      const params = {
        userId: this.userId
      }
      listByUserId(params).then(res => {
        if (res.data.code === 200 || res.data.code === 0) {
          if (res.data.data.length > 0) {
            console.log(res.data.data)
            this.form.roleIds = res.data.data.map(v => v.roleId)
            this.charactorOptions = res.data.data
          } else {
            return false
          }
        }
      })
    },
    closeDialog () {
      this.$emit('closeAssignDialog')
    },
    submitForm () {
      console.log(this.form)
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const roleIds = this.form.roleIds.join(',')
          const params = {
            userId: this.form.userId,
            roleIds: roleIds
          }
          bindRole(params).then((res) => {
            if (res.data.code === 200 || res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '分配成功'
              })
              this.$emit('closeAssignDialog', 1)
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
  .sel{
    /deep/ .el-icon-close{
      display: none;
    }
  }

  /deep/ .el-select-dropdown{
    z-index: 0;
    display: none;
  }
</style>
